// export { default as BrandGraphic } from './brandGraphic.icon';
export { default as QuoteMark } from './quoteMark.icon';
